import routes from "../constants/routes";
import tokenUtils from "../utils/tokenUtils";
import camelizeKeys from "../utils/camelizeKeys";

export default async function fetchJSON(url, options = {}) {
  const token = tokenUtils.getToken();

  return new Promise((resolve, reject) => {
    const newOptions = {
      method: options.method,
      mode: "cors",
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
      },
    };

    if (options.body && !(options.body instanceof FormData)) {
      newOptions.headers["Content-Type"] = "application/json";
      newOptions.body = JSON.stringify(options.body);
    } else {
      newOptions.body = options.body;
    }

    fetch(url, newOptions)
      .then(async (response) => {
        const json = await response.json().catch(() => null);
        if (!response.ok) {
          if (response.status === 401) {
            tokenUtils.deleteToken();
            window.location.href = `${routes.login.root}?redirect=${window.location.pathname}`;
            return;
          }
          reject({
            statusCode: response.status,
            statusText: response.statusText,
            message:
              response.status >= 500
                ? "Something went wrong, please try again later."
                : Array.isArray(json?.detail)
                  ? json.detail
                      .map((err) => err.msg || "Unknown error")
                      .join(", ")
                  : typeof json?.detail === "string"
                    ? json.detail
                    : json?.message || "An error occurred",
            data: json || null,
          });
        } else {
          resolve({
            statusCode: response.status,
            statusText: response.statusText,
            ...(json ? camelizeKeys(json) : { message: "No JSON returned" }),
          });
        }
      })
      .catch((error) => {
        reject({
          statusCode: 0,
          message: error.message || "Network error",
          data: null,
        });
      });
  });
}
